import { buildBinderListings } from '@monofe/di';
import bindClient from './client/bind';
import bindMessage from './message/bind';
import bindUtil from './util/bind';

export default buildBinderListings([bindClient, bindUtil, bindMessage]);
